export default __webpack_public_path__ + "static/media/userprofile.841d6517.svg";